import { Injectable } from '@angular/core';
import type { PrimaryPaletteDto } from '@millionshow/api-client';

@Injectable({ providedIn: 'root' })
export class KioskThemeService {
  apply(palette: PrimaryPaletteDto): void {
    if (typeof document === 'undefined') return;
    const root = document.documentElement;
    Object.entries(palette).forEach(([shade, color]) =>
      root.style.setProperty(`--color-primary-${shade}`, color)
    );
    root.style.setProperty('--color-primary', palette[500]);
    root.style.backgroundColor = palette[700];
    document.body.style.backgroundColor = palette[700];
  }
}
